import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { CoreSubject } from '@ts-core/modules/subjects/types';
import GenericList from '@ts-core/core/components/GenericList';
import Button from '@ts-core/components/Button';

import { useExercises } from '../../hooks';
import { Exercise } from '../../types';

import AvailableExercisesListItem from './AvailableExercisesListItem';

interface AvailableExercisesListProps {
  subject: CoreSubject;

  isExerciseSelected: (exercise: Exercise) => boolean;
  onAddExercise: (exercise: Exercise) => void;
  onAddExercises: (exercise: Exercise[]) => void;
  onRemoveExercise: (exercise: Exercise) => void;
}
const AvailableExercisesList = (props: AvailableExercisesListProps) => {
  const { subject, isExerciseSelected, onAddExercise, onAddExercises, onRemoveExercise } = props;
  const intl = useIntl();

  const { exercises, loading } = useExercises({ courseId: subject.course, subjectId: subject.id });
  const exercisesCount = exercises?.length || 0;

  const handleAddAllExercises = useCallback(() => {
    if (exercises) {
      onAddExercises(exercises);
    }
  }, [onAddExercises, exercises]);

  return (
    <>
      {exercisesCount > 0 && (
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Button size="small" color="secondary" onClick={handleAddAllExercises}>
            {intl.formatMessage({ id: 'button.addAllExercises' })}
          </Button>
        </Box>
      )}
      <GenericList
        items={exercises}
        loading={loading}
        skeletonsCount={1}
        emptyMessage={
          <ListItem disabled>
            <ListItemText primary={intl.formatMessage({ id: 'assignment.noAvailableExercisesInSubject' })} />
          </ListItem>
        }
        disableEmptyMessageContainer
        renderItem={(index, exercise) => (
          <AvailableExercisesListItem
            key={exercise?.id || index}
            exercise={exercise}
            loading={loading}
            isExerciseSelected={isExerciseSelected}
            onAddExercise={onAddExercise}
            onRemoveExercise={onRemoveExercise}
          />
        )}
      />
    </>
  );
};

export default AvailableExercisesList;
